module.exports = __webpack_public_path__ + "static/media/takeaway.bd93829d.svg";